module.exports = __webpack_public_path__ + "school/img/culturalConfidenceDetailBg.b89ad38b.jpg";